import React, { useState, useRef } from 'react';
import SendRoundedIcon from '@mui/icons-material/SendRounded';

const SUGGESTIONS = [
  {
    emoji: '📢',
    bg: '#fef3c7',
    title: 'Communicatieadviseur',
    subtitle: 'Interne communicatie & change',
  },
  {
    emoji: '📈',
    bg: '#dbeafe',
    title: 'Marketing Manager',
    subtitle: 'Strategie & campagnes',
  },
  {
    emoji: '🧑‍💼',
    bg: '#dcfce7',
    title: 'HR Business Partner',
    subtitle: 'People & organisatie',
  },
  {
    emoji: '✍️',
    bg: '#ede9fe',
    title: 'Content Strateeg',
    subtitle: 'Content & storytelling',
  },
];

export default function GPTMakerLanding({ onSubmit }) {
  const [input, setInput] = useState('');
  const textareaRef = useRef(null);

  const handleSubmit = () => {
    if (!input.trim()) return;
    onSubmit(input.trim());
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleSuggestionClick = (suggestion) => {
    const text = `${suggestion.title}. ${suggestion.subtitle}.`;
    setInput(text);
    textareaRef.current?.focus();
  };

  return (
    <div className="gpt-landing">
      {/* Logo */}
      <div className="gpt-landing-logo">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <defs>
            <linearGradient id="logoGrad" x1="0" y1="0" x2="48" y2="48">
              <stop offset="0%" stopColor="#6366f1" />
              <stop offset="50%" stopColor="#8b5cf6" />
              <stop offset="100%" stopColor="#ec4899" />
            </linearGradient>
          </defs>
          <rect x="4" y="12" width="18" height="24" rx="9" fill="url(#logoGrad)" opacity="0.9" />
          <rect x="26" y="12" width="18" height="24" rx="9" fill="url(#logoGrad)" opacity="0.7" />
          <rect x="18" y="18" width="12" height="4" rx="2" fill="url(#logoGrad)" />
        </svg>
        <h1>
          SuperAgents<sup>™</sup>
        </h1>
      </div>

      {/* Input */}
      <div className="gpt-input-container">
        <textarea
          ref={textareaRef}
          className="gpt-input-textarea"
          placeholder="Beschrijf de rol of functie waarvoor je een Super GPT wilt bouwen..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          maxLength={500}
          rows={3}
        />
        <div className="gpt-input-actions">
          <div />
          <button
            className="gpt-input-send-btn"
            onClick={handleSubmit}
            disabled={!input.trim()}
            title="GPT Builder starten"
          >
            <SendRoundedIcon sx={{ fontSize: 18 }} />
          </button>
        </div>
      </div>

      {/* Suggestions */}
      <div className="gpt-suggestions">
        {SUGGESTIONS.map((s, i) => (
          <div
            key={i}
            className="gpt-suggestion-card"
            onClick={() => handleSuggestionClick(s)}
          >
            <div
              className="gpt-suggestion-avatar"
              style={{ background: s.bg }}
            >
              {s.emoji}
            </div>
            <div className="gpt-suggestion-text">
              <h4>{s.title}</h4>
              <p>{s.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
